import React from 'react';
import { ArrowRightIcon, CheckIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { volumes, insideEveryVolume } from '../data/volumes';
export function Volumes() {
  return <Section background="white" labelledBy="volumes-heading" data-id="element-308" data-mp="1c5788ndsh702">
      <h2 id="volumes-heading" className="mx-auto max-w-3xl text-center font-serif text-[27px] font-semibold leading-[1.15] text-ink sm:text-3xl lg:text-[44px]" data-id="element-309" data-mp="1c3e3jdmqkwup">
        Six volumes. Thirty-nine Quick Cards. Zero improvising.
      </h2>

      <ol className="mt-14 space-y-5" data-id="element-310" data-mp="1qtblhbu2oqbg">
        {volumes.map(volume => <li key={volume.number} className="grid grid-cols-1 gap-5 rounded-2xl border border-sage/15 bg-paper p-6 shadow-card sm:grid-cols-[auto_1fr] sm:gap-8 sm:p-8" data-id="element-311" data-mp="1vsy8ue3m7mxz">
            <p className="font-serif text-4xl font-semibold leading-none text-sage/35 sm:text-5xl" data-id="element-312" data-mp="keu7unym0yjf">
              {volume.number}
            </p>

            <div data-id="element-313" data-mp="3o8f0268dh1ku">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-314" data-mp="3o9ztfsiyaeh4">
                <h3 className="font-serif text-2xl font-semibold leading-tight text-ink sm:text-[28px]" data-id="element-315" data-mp="3jawnm5v5c483">
                  {volume.title}
                </h3>
                {volume.flag && <span className="inline-flex items-center gap-1.5 rounded-full bg-brass/12 px-3 py-1 font-sans text-[11px] font-semibold uppercase tracking-[0.12em] text-brass" data-id="element-316" data-mp="3t5ydx515rcc9">
                    <StarIcon className="h-3 w-3 fill-brass" strokeWidth={0} aria-hidden="true" data-id="element-317" data-mp="61sa0hlt1qcb" />
                    {volume.flag}
                  </span>}
              </div>

              {volume.subtitle && <p className="mt-2 font-sans text-[13px] font-semibold uppercase tracking-[0.1em] text-brass" data-id="element-318" data-mp="fug4v6t85k8e">
                  {volume.subtitle}
                </p>}

              <p className="mt-3 font-sans text-[16px] leading-[1.65] text-ink-soft" data-id="element-319" data-mp="ps3ytuj0anpi">
                {volume.body}
              </p>

              <p className="mt-5 flex items-start gap-2 font-sans text-[15px] font-semibold leading-snug text-sage" data-id="element-320" data-mp="11stzdu9zi0v3">
                <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-321" data-mp="16rdmhy0bdip1" />
                {volume.result}
              </p>
            </div>
          </li>)}
      </ol>

      <div className="mt-10 rounded-2xl bg-sage-soft p-6 sm:p-8" data-id="element-322" data-mp="1kjbntmnsaaan">
        <h3 className="font-sans text-[12px] font-semibold uppercase tracking-[0.14em] text-sage" data-id="element-323" data-mp="1khqw04sut5gh">
          Inside every volume
        </h3>
        <ul className="mt-5 grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-324" data-mp="1uh7xea12ox6n">
          {insideEveryVolume.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-325" data-mp="3rb2zzrjj3o3o">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={2.25} aria-hidden="true" data-id="element-326" data-mp="2ylnx9eh4vd" />
              <span className="font-sans text-[15px] leading-snug text-ink-soft" data-id="element-327" data-mp="2dfkxgco5pgn8">{item}</span>
            </li>)}
        </ul>
      </div>

      <div className="mt-14 flex flex-col items-center" data-id="element-328" data-mp="24mhly9x2ndv8">
        <CtaButton href="#pricing" data-id="element-329" data-mp="1zmbq0hjrr57c">I want the complete system</CtaButton>
        <TrustRow className="mt-4 justify-center" data-id="element-330" data-mp="1zo6axvv1ixbf" />
      </div>
    </Section>;
}